import React from "react";

import styles from "./AppearanceTabSettingsContainer.module.css"
import {CustomSwitchField} from "../customSwitchField/CustomSwitchField";

interface SectionProps {
    title: string
    withSwitch?: boolean
    onSwitchChange?: (value: boolean) => void
    switchValue?: boolean
    children: any
}

export const AppearanceTabSettingsContainer: React.FC<SectionProps> = ({title, withSwitch, onSwitchChange, switchValue = true, children}) => {
    return <div className={styles.wrapper}>
        <div className={styles.title}>
            <h5 style={{marginBottom: "0px"}}>{title}</h5>
            {withSwitch && <div className={styles.switchWrapper}>
                <CustomSwitchField
                    textOnTrue={"On"}
                    textOnFalse={"Off"}
                    value={switchValue}
                    toggleValue={(v) => onSwitchChange && onSwitchChange(v)}
                />
            </div>}
        </div>
        {(switchValue) && <div className={styles.fieldsWrapper}>{children}</div>}
    </div>
}
